import { ComponentProps, useState } from 'react';
import { isBadOrEmptyString } from '../../predicates/string';
import { isUndefined } from '../../predicates/type';
import { blue } from '../Color';
import { floatFormat } from '../CustomForm/utils/format/number';
import { FlexGrid, FlexGridColumn } from '../FlexGrid';
import { IconButton } from '../IconButton';
import { Visibility } from '../Icons/Visibility';
import { PasswordTextBoxProps } from '../PasswordTextbox/PasswordTextBox';
import classes from '../PasswordTextbox/styles/passwordPreview.module.scss';
import { withPreview } from '../decorators/withPreview';
import { NumberTextbox } from './NumberTextbox';
import { NumberTextboxProps } from './types';

type NumberTextBoxWithPasswordPreviewProps = PasswordTextBoxProps & {
	hasButton?: boolean;
};

export const formatNumberTextBoxPreview = ({ value, decimalScale, allowComma }: NumberTextboxProps) => {
	if (isUndefined(allowComma)) {
		return value;
	}

	const formatOptions: Parameters<typeof floatFormat>[0] = {};

	if (!isUndefined(decimalScale)) {
		formatOptions.decimalScale = decimalScale;
	}

	return floatFormat(formatOptions)(value);
};

export const NumberTextBoxWithPreview = withPreview<ComponentProps<typeof NumberTextbox>>(
	NumberTextbox,
	formatNumberTextBoxPreview,
);

export const FormatNumberTextBoxWithPasswordPreview = ({
	value,
	hasButton = true,
}: NumberTextBoxWithPasswordPreviewProps) => {
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);

	const formattedValue = () => (isPasswordVisible ? value : Array(9).fill('•').join(''));

	if (isBadOrEmptyString(value)) {
		return null;
	}

	return (
		<FlexGrid
			center
			spaceBetween
		>
			<FlexGridColumn>{formattedValue()}</FlexGridColumn>
			{hasButton && (
				<FlexGridColumn>
					<IconButton
						onClick={() => setIsPasswordVisible((prevState) => !prevState)}
						dataTestId='passwordPreviewVisibilityButton'
						link
						className={classes.icon_button}
					>
						<Visibility fill={isPasswordVisible ? blue[5] : undefined} />
					</IconButton>
				</FlexGridColumn>
			)}
		</FlexGrid>
	);
};
